<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33333 2.5H2.5V8.33333H8.33333V2.5Z"
      stroke="currentColor"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5 2.5H11.6667V8.33333H17.5V2.5Z"
      stroke="currentColor"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5 11.6667H11.6667V17.5H17.5V11.6667Z"
      stroke="currentColor"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33333 11.6667H2.5V17.5H8.33333V11.6667Z"
      stroke="currentColor"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>